<template>
    <b-container>
        <b-row v-if="editData.length>0">
            <b-col md="12" class="table-responsive">
                <b-table  bordered hover v-if="editData.length>0" :items="editData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                        {{ $n(data.index + 1 ) }}
                    </template>
                    <template v-slot:cell(image)="data">
                        <span v-if="$route.query.id"><a target="_blank" :href="baseUrl + 'storage' + '/grant-panel' + '/' + data.item.attachment" :title="$t('externalUser.bank_certificate')" class="mr-3"><i class="ri-download-cloud-fill"></i></a>
                            {{ $t('globalTrans.download') }}</span>
                        <span v-else><a :href="grantAllowanceServiceBaseUrl + 'download-attachment?file='+ path +'/' + data.item.attachment" target="_blank" v-if="data.item.attachment">
                            {{ $t('globalTrans.download') }}
                            <i class="ri-download-cloud-line" ></i>
                        </a></span>
                    </template>
                    <template v-slot:cell(action)="data">
                        <b-button id="button-5" @click="deleteEditDocument(data.item)" variant="danger" class="mr-2" ><i style="margin-right: 0" class="ri-delete-bin-line"></i></b-button>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <b-row v-for="(document,index) in documents" :key="index">
            <b-col sm="12" md= "4" lg="4" xl="4">
                <ValidationProvider name="Document title (En)" :vid="`document_title${index}`">
                    <b-form-group
                        class="row"
                        label-cols-sm="12"
                        :label-for="'document_title'+index"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label><span v-if="service_name_check == 5">{{ $t('externalUser.imp_doc_en')}}</span><span v-else>{{ $t('social_service.document_title_en')}}</span></template>
                        <b-form-input
                            class="form-control"
                            v-model="document.title"
                            @keyup="dataReturn"
                            :id="`document_title${index}`"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="false"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            :aria-describedby="`document_title${index}_help document_title${index}_error`"
                        ></b-form-input>
                        <!-- Help text -->
                        <b-form-text
                        :id="`document_title${index}_help`"
                        class="sr-only"
                        >
                        Enter the document title in English.
                        </b-form-text>

                        <!-- Error message (always in DOM) -->
                        <div
                        :id="`document_title${index}_error`"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] || '' }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col sm="12" md= "4" lg="4" xl="4">
                <ValidationProvider name="Document title (Bn)" :vid="`document_title_bn${index}`">
                    <b-form-group
                        class="row"
                        label-cols-sm="12"
                        :label-for="'document_title_bn'+index"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label><span v-if="service_name_check == 5">{{ $t('externalUser.imp_doc_bn')}}</span><span v-else>{{ $t('social_service.document_title_bn')}}</span></template>
                        <b-form-input
                            class="form-control"
                            v-model="document.title_bn"
                            @keyup="dataReturn"
                            :id="`document_title_bn${index}`"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="false"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            :aria-describedby="`document_title_bn${index}_help document_title_bn${index}_error`"
                        ></b-form-input>
                        <!-- Help text -->
                        <b-form-text
                        :id="`document_title_bn${index}_help`"
                        class="sr-only"
                        >
                        Enter the document title in Bangla.
                        </b-form-text>

                        <!-- Error message (always in DOM) -->
                        <div
                        :id="`document_title_bn${index}_error`"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] || '' }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col sm="12" md= "3" lg="3" xl="3">
                <ValidationProvider name="Upload" :vid="`attachment${index}`">
                    <b-form-group
                        class="row"
                        label-cols-sm="12"
                        :label-for="'attachment'+index"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{ $t('externalUser.upload')}}
                        </template>
                        <b-form-file
                            :id="`attachment${index}`"
                            v-model="document.attachment"
                            @change="onChange($event, index)"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="false"
                            :aria-invalid="errors.length || document.fileError ? 'true' : 'false'"
                            :aria-describedby="`attachment${index}_help attachment${index}_error attachment${index}_file_error`"
                        >
                        </b-form-file>
                        <!-- Help text -->
                        <b-form-text
                        :id="`attachment${index}_help`"
                        class="sr-only"
                        >
                        Upload your document file (PDF, image, or document format).
                        </b-form-text>

                        <!-- Validation error message (always in DOM) -->
                        <div
                        :id="`attachment${index}_error`"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] || '' }}
                        </div>

                        <!-- File size error (always in DOM) -->
                        <div
                        :id="`attachment${index}_file_error`"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        v-if="document.fileError"
                        style="color: red"
                        >
                        {{$t('externalUser.file_size')}}
                        </div>
                        <!-- <div class="invalid-feedback d-block" v-if="document.fileError" style="color: red">{{$t('externalUser.file_size')}}</div> -->
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col sm="12" md= "1" lg="1" xl="1" class="d-flex" style="margin-top: 42px">
                <button
                    v-if="index !== 0"
                    @click="deleteDocument(index)"
                    @keyup.enter="deleteDocument(index)"
                    type="button"
                    class="btn btn-danger btn-sm mr-2 mb-4"
                    :title="$t('globalTrans.delete')"
                    :aria-label="$t('globalTrans.delete')"
                    >
                    <i class="ri-delete-bin-line m-0" aria-hidden="true"></i>
                </button>
                 <button
                    v-if="documents.length - 1 === index"
                    @click="addDocument"
                    @keyup.enter="addDocument"
                    type="button"
                    class="btn btn-success btn-sm mb-4"
                    :title="$t('institute_manangement.add')"
                    :aria-label="$t('institute_manangement.add')"
                    >
                    <i class="ri-add-line m-0" aria-hidden="true"></i>
                </button>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
 import { grantAllowanceServiceBaseUrl } from '@/config/api_config'
export default {
    props: ['path', 'data', 'service_name_check'],
    components: {
        ValidationProvider
    },
    data () {
        return {
            documents: [{ title: '', title_bn: '', attachment: [], file: '', fileError: false }],
            id: '',
            editData: '',
            baseUrl: grantAllowanceServiceBaseUrl,
            grantAllowanceServiceBaseUrl
        }
    },
    created () {
        if (this.data.length > 0) {
          this.editData = this.data
          this.editData.map((document) => {
              document.title = document.document_title
              document.title_bn = document.document_title_bn
            })
            this.dataReturn()
        }
        this.id = this.$route.query.id
    },
    computed: {
        columns () {
            const labels = [
                { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
                { label: this.$t('social_service.document_title_en'), class: 'text-left' },
                { label: this.$t('social_service.document_title_bn'), class: 'text-left' },
                { label: this.$t('externalUser.image'), class: 'text-left' },
                { label: this.$t('globalTrans.action'), class: 'text-center' }
            ]

            const keys = [
                { key: 'index' },
                { key: 'document_title' },
                { key: 'document_title_bn' },
                { key: 'image' },
                { key: 'action' }
            ]

            return labels.map((item, index) => {
                return Object.assign(item, keys[index])
            })
        }
    },
    methods: {
        deleteEditDocument (data) {
         this.editData = this.editData.filter(document => document.id !== data.id)
         this.dataReturn()
        },
        showTrash () {
            const length = this.documents.length
            if (length === 1) {
                return false
            }
            return true
        },
        onChange (event, index) {
            this.documents[index].fileError = event.target.files[0].size > this.$store.state.ExternalUser.commonObj.fileSize
            const input = event.target
            if (input.files && input.files[0]) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.documents[index].file = e.target.result
                }
                reader.readAsDataURL(input.files[0])
            } else {
                this.documents[index].file = ''
            }
            this.dataReturn()
        },
        dataReturn () {
            let documents
            if (this.editData) {
                documents = [...this.editData, ...this.documents]
            } else {
                documents = this.documents
            }
            this.$emit('document-data', documents)
        },
        showAdd (index) {
            const length = this.documents.length
            if (index === length - 1) {
                return true
            }
            return false
        },
        addDocument () {
            const obj = { title: '', attachment: [], file: '', fileError: false }
            this.documents.push(obj)
        },
        deleteDocument (i) {
            this.documents = this.documents.filter((_, index) => index !== i)
        }
    }
}
</script>
<style lang="scss" scoped>
    .badge {
        height: 20px !important;
    }
</style>
